import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

import type { AllowListFormSchemaValues } from 'src/features/parkingManagement/api/AllowListAPI/useCreateAllowList';
import type { AllowList } from 'src/features/parkingManagement/types/allowList';

export type MutationFnType = typeof mutationFn;

const RESOURCE = '/parkings/:parkingId/allow-list/:listId/';

export interface DTO extends AllowListFormSchemaValues {
    parkingId: string;
    listId: string;
}

const mutationFn = ({ parkingId, listId, ...data }: DTO): Promise<AllowList> => {
    return axios.patch(formatResourcePath(RESOURCE, { parkingId, listId }), data);
};

interface UseCreateAdditionalServicesOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}

export const useMutationHook = (options: UseCreateAdditionalServicesOptions) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateAllowList };
